// HARDCODE
export default {
  GOOGLE_MAPS_API_KEY: 'AIzaSyBjBippYWPUEx2Fe17WXT4FzJaB_xioej8',
};
